module.exports = __webpack_public_path__ + "static/img/add_plan_icon.9ae200a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/add_plan_icon.jpg
// module id = foV+
// module chunks = 1